<template>
    <section class="user-routine">
        <!-- Loading -->
        <loading />

        <div class="user-routine-content">
            <div class="header-wrapper">
                <!-- Breadcrumb -->
                <div class="turnback">
                    <!-- Back To -->
                    <back-to :urlreference="moduledefaultindex" />
                </div>

                <h1 v-if="showformcreate" class="heading-4">
                    {{ headertitle }}
                </h1>
            </div>

            <!-- Content -->
            <div
                v-if="showformcreate || showformupdate"
                class="user-module-base"
            >
                <div class="users-module-content">
                    <div
                        v-if="showformupdate"
                        class="users-module-content-flex-wrapper"
                    >
                        <!-- First Content -->
                        <div class="first-content">
                            <div class="first-content-information-wrapper">
                                <img
                                    :src="moduleData[0].image"
                                    alt="User Icon"
                                />

                                <div class="content-information">
                                    <h1 class="heading-4">
                                        {{ moduleData[0].user_name }}
                                    </h1>
                                    <p>
                                        {{
                                            moduleData[0].user_rule !==
                                            parseInt(professionalrule)
                                                ? `${userRule} - Desde ${moduleData[0].created_at}`
                                                : `${userRule} - ${moduleData[0].categories} - Desde ${moduleData[0].created_at}`
                                        }}
                                    </p>
                                </div>
                            </div>

                            <div class="first-content-buttons-wrapper">
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    :data-userid="moduleData[0].user_id"
                                    data-action="recoverpass"
                                    @click="buttonActions($event)"
                                    :disabled="disabled"
                                >
                                    <span class="button-body"
                                        >Recuperar palavra-passe</span
                                    >
                                </button>

                                <button
                                    v-if="
                                        moduleData[0].user_rule ===
                                        parseInt(professionalrule)
                                    "
                                    type="button "
                                    class="btn"
                                    :class="
                                        moduleData[0].active === 'Ativo'
                                            ? 'btn-danger'
                                            : 'btn-success'
                                    "
                                    :data-userid="moduleData[0].professional_id"
                                    :data-userrule="moduleData[0].user_rule"
                                    :data-active="
                                        moduleData[0].active.toLowerCase()
                                    "
                                    data-action="blockuser"
                                    @click="buttonActions($event)"
                                    :disabled="disabled"
                                >
                                    <span class="button-body">
                                        {{
                                            moduleData[0].active === "Ativo"
                                                ? "Bloquear utilizador"
                                                : "Desbloquear utilizador"
                                        }}</span
                                    >
                                </button>
                            </div>
                        </div>

                        <!-- Second Content -->
                        <div class="second-content details-section-wrapper">
                            <h3 class="heading-6 detail-section-title">
                                Detalhes pessoais
                            </h3>

                            <div class="details-section-content">
                                <div
                                    v-for="(val, index) in personalDetails"
                                    :key="index"
                                    :data-referindex="index"
                                    class="details-item"
                                >
                                    <template v-if="val.value !== null">
                                        <p class="button-body color-text-body">
                                            {{ val.input }}
                                            <span class="mobile-two-dots">
                                                :</span
                                            >
                                        </p>
                                        <p class="button-body">
                                            {{ val.value }}
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <!-- Only for Professinal users -->
                        <template
                            v-if="
                                moduleData[0].user_rule ===
                                parseInt(professionalrule)
                            "
                        >
                            <!-- Third Content -->
                            <div class="third-content details-section-wrapper">
                                <h3 class="heading-6 detail-section-title">
                                    Morada
                                </h3>

                                <div class="details-section-content">
                                    <div class="details-item">
                                        <p class="button-body color-text-body">
                                            Morada
                                            <span class="mobile-two-dots">
                                                :</span
                                            >
                                        </p>
                                        <p class="button-body">
                                            {{
                                                moduleData[0].contact
                                                    .default_address.address
                                            }}
                                        </p>
                                    </div>

                                    <div class="details-item">
                                        <p class="button-body color-text-body">
                                            Código Postal<span
                                                class="mobile-two-dots"
                                                >:</span
                                            >
                                        </p>
                                        <p class="button-body">
                                            {{
                                                moduleData[0].contact
                                                    .default_address.postalcode
                                            }}
                                        </p>
                                    </div>

                                    <div class="details-item">
                                        <p class="button-body color-text-body">
                                            Cidade
                                            <span class="mobile-two-dots">
                                                :</span
                                            >
                                        </p>
                                        <p class="button-body">
                                            {{
                                                moduleData[0].contact
                                                    .default_address.city
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Dados a mostrar -->
                            <div class="choose-section-wrapper">
                                <h2 class="heading-5">Dados a mostrar</h2>
                                <div class="choose-btns">
                                    <button
                                        class="btn show-user-usage active"
                                        data-action="perfil"
                                        @click="navActions($event)"
                                        :disabled="
                                            Object.values(
                                                moduleData[0].booking_data
                                            ).length === 0
                                        "
                                    >
                                        <span class="button-body"
                                            >Perfil de utilização</span
                                        >
                                    </button>
                                    <button
                                        class="btn show-user-history"
                                        data-action="history"
                                        @click="navActions($event)"
                                        :disabled="
                                            Object.values(
                                                moduleData[0].booking_data
                                            ).length === 0
                                        "
                                    >
                                        <span class="button-body"
                                            >Histórico de reservas</span
                                        >
                                    </button>
                                </div>
                            </div>

                            <!-- Fourty Content -->
                            <div
                                v-if="
                                    Object.values(moduleData[0].booking_data)
                                        .length > 0
                                "
                                class="fourty-content"
                            >
                                <!-- Perfil Content -->
                                <div class="perfil-content" ref="perfil">
                                    <!-- User Frequency -->
                                    <div class="details-section-wrapper">
                                        <h3
                                            class="heading-6 section-title user-frequency"
                                        >
                                            Frequência do utilizador
                                        </h3>

                                        <p class="strong-600">
                                            Dados referente a:
                                        </p>

                                        <div class="select-year">
                                            <p class="button-body">
                                                {{ currentYear }}
                                            </p>
                                        </div>

                                        <!-- Cards Content -->
                                        <div class="cards-content">
                                            <div class="card-wrapper">
                                                <p
                                                    class="card-title total-spent"
                                                >
                                                    Total gasto
                                                </p>

                                                <p
                                                    class="card-main-item heading-4 euro"
                                                >
                                                    {{
                                                        `${moduleData[0].booking_data.totalSpend}`
                                                    }}
                                                </p>

                                                <small
                                                    class="caption-md color-text-body"
                                                    >{{
                                                        `Média de € ${moduleData[0].booking_data.totalSpendMonthly} mensais`
                                                    }}</small
                                                >
                                            </div>

                                            <div class="card-wrapper">
                                                <p
                                                    class="card-title top-activity-month"
                                                >
                                                    Mês de Maior Atividade
                                                </p>

                                                <p
                                                    class="card-main-item heading-4"
                                                >
                                                    {{
                                                        moduleData[0]
                                                            .booking_data
                                                            .hightestActivityMonthy
                                                    }}
                                                </p>

                                                <small
                                                    class="caption-md color-text-body"
                                                >
                                                    Referente ao ano atual
                                                </small>
                                            </div>

                                            <div class="card-wrapper">
                                                <p
                                                    class="card-title most-common-day"
                                                >
                                                    Dia mais comum
                                                </p>

                                                <p
                                                    class="card-main-item heading-4"
                                                >
                                                    {{
                                                        moduleData[0]
                                                            .booking_data
                                                            .comumnWeekDay
                                                    }}
                                                </p>

                                                <small
                                                    class="caption-md color-text-body"
                                                >
                                                    Dia da semana com mais
                                                    reservas
                                                </small>
                                            </div>

                                            <div class="card-wrapper">
                                                <p
                                                    class="card-title most-booked-time"
                                                >
                                                    Período mais reservado
                                                </p>

                                                <p
                                                    class="card-main-item heading-4"
                                                >
                                                    {{
                                                        moduleData[0]
                                                            .booking_data
                                                            .mostComumnTurn
                                                    }}
                                                </p>

                                                <small
                                                    class="caption-md color-text-body"
                                                >
                                                    Manhã ou Tarde
                                                </small>
                                            </div>

                                            <div class="card-wrapper">
                                                <p
                                                    class="card-title most-booked-time"
                                                >
                                                    Total de pedidos
                                                </p>

                                                <p
                                                    class="card-main-item heading-4"
                                                >
                                                    {{
                                                        moduleData[0]
                                                            .booking_data
                                                            .total_booking_group
                                                    }}
                                                </p>

                                                <small
                                                    class="caption-md color-text-body"
                                                >
                                                    Total de pedidos feitos até
                                                    á data
                                                </small>
                                            </div>

                                            <div class="card-wrapper">
                                                <p
                                                    class="card-title most-booked-time"
                                                >
                                                    Total de reservas
                                                </p>

                                                <p
                                                    class="card-main-item heading-4"
                                                >
                                                    {{
                                                        moduleData[0]
                                                            .booking_data
                                                            .bookingTotal
                                                    }}
                                                </p>

                                                <small
                                                    class="caption-md color-text-body"
                                                >
                                                    Total de reservas feitas até
                                                    á data
                                                </small>
                                            </div>

                                            <div class="triple-card-wrapper">
                                                <div class="card-wrapper">
                                                    <p
                                                        class="card-title weekly-avarage"
                                                    >
                                                        Média semanal
                                                    </p>

                                                    <p
                                                        class="card-main-item heading-4"
                                                    >
                                                        {{
                                                            `${moduleData[0].booking_data.weeklyAvg}`
                                                        }}
                                                        <span
                                                            class="body-1 color-text-action strong-400"
                                                            >reservas</span
                                                        >
                                                    </p>
                                                </div>

                                                <div class="card-wrapper">
                                                    <p
                                                        class="card-title montly-avarage"
                                                    >
                                                        Média mensal
                                                    </p>

                                                    <p
                                                        class="card-main-item heading-4"
                                                    >
                                                        {{
                                                            `${moduleData[0].booking_data.monthAvg}`
                                                        }}
                                                        <span
                                                            class="body-1 color-text-action strong-400"
                                                            >reservas</span
                                                        >
                                                    </p>
                                                </div>

                                                <div class="card-wrapper">
                                                    <p
                                                        class="card-title anual-avarage"
                                                    >
                                                        Média anual
                                                    </p>

                                                    <p
                                                        class="card-main-item heading-4 anual-avarage"
                                                    >
                                                        {{
                                                            `${moduleData[0].booking_data.yearAvg}`
                                                        }}
                                                        <span
                                                            class="body-1 color-text-action strong-400"
                                                            >reservas</span
                                                        >
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                class="details-section-wrapper-grey"
                                            >
                                                <p>Espaço mais usado</p>
                                                <p
                                                    class="heading-4 color-text-action space-name"
                                                >
                                                    {{
                                                        moduleData[0]
                                                            .booking_data
                                                            .mostUsedSpace.name
                                                    }}
                                                </p>
                                                <small
                                                    class="caption-md color-text-body"
                                                    >Este espaço foi reservado
                                                    {{
                                                        moduleData[0]
                                                            .booking_data
                                                            .mostUsedSpace.total
                                                    }}
                                                    vezes</small
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Chart Content -->
                                    <div
                                        class="details-section-wrapper chart-content"
                                    >
                                        <h3
                                            class="heading-6 section-title user-booking"
                                        >
                                            Reservas
                                            <span
                                                class="caption-lg color-text-body"
                                                >( Total:
                                                {{
                                                    moduleData[0].booking_data
                                                        .bookingTotal
                                                }}
                                                )</span
                                            >
                                        </h3>

                                        <div class="chart-container">
                                            <chart-bar
                                                :bookingdata="
                                                    moduleData[0].booking_data
                                                        .chartData
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <!-- History Content -->
                                <div
                                    class="history-content d-none"
                                    ref="history"
                                >
                                    <div class="history-content-flex">
                                        <div class="history-header">
                                            <div class="history-header-content">
                                                <h3
                                                    class="heading-6 section-title user-booking"
                                                >
                                                    Reservas
                                                    <span
                                                        class="caption-lg color-text-body"
                                                    >
                                                        &nbsp;{{
                                                            ` ( Total: ${moduleData[0].booking_data.bookingTotal} )`
                                                        }}
                                                    </span>
                                                </h3>

                                                <div class="filters-section">
                                                    <div class="tab-wrapper">
                                                        <span
                                                            role="button"
                                                            class="button-body buttonlist active"
                                                            aria-label="Active Booking"
                                                            data-action="current"
                                                            ref="buttonlist"
                                                            @click="
                                                                navActions(
                                                                    $event
                                                                )
                                                            "
                                                            >Ativas</span
                                                        >

                                                        <span
                                                            role="button"
                                                            class="button-body buttonlist"
                                                            aria-label="Desactive Booking"
                                                            data-action="old"
                                                            ref="buttonlist"
                                                            @click="
                                                                navActions(
                                                                    $event
                                                                )
                                                            "
                                                            >Passadas</span
                                                        >
                                                    </div>

                                                    <div class="inputs-wrapper">
                                                        <div
                                                            class="input-group"
                                                        >
                                                            <select
                                                                class="form-select w-100"
                                                                id="filtermonth"
                                                                aria-label="Select Month"
                                                                :disabled="
                                                                    disabledfilter
                                                                "
                                                                @change="
                                                                    filterItem(
                                                                        $event
                                                                    )
                                                                "
                                                            >
                                                                <option
                                                                    v-for="(
                                                                        value,
                                                                        index
                                                                    ) in customModuleData.months"
                                                                    :key="index"
                                                                    :value="
                                                                        value
                                                                    "
                                                                >
                                                                    {{ value }}
                                                                </option>
                                                            </select>

                                                            <button
                                                                type="button"
                                                                class="btn btn-primary"
                                                                @click="
                                                                    filterClear()
                                                                "
                                                            >
                                                                Limpar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="cards-wrapper">
                                            <figure
                                                v-for="(
                                                    value, index
                                                ) in bookingHistoryRoutine"
                                                :key="index"
                                            >
                                                <div class="img-wrapper">
                                                    <img
                                                        :src="
                                                            value.media[0].files
                                                                .thumb
                                                        "
                                                        :alt="value.office_name"
                                                    />
                                                </div>

                                                <figcaption class="">
                                                    <h6 class="card-title">
                                                        {{ value.office_name }}
                                                    </h6>
                                                    <template
                                                        v-for="(
                                                            valbooking,
                                                            indexbooking
                                                        ) in value.booking"
                                                        :key="indexbooking"
                                                    >
                                                        <div
                                                            class="card-information-wrapper"
                                                        >
                                                            <p
                                                                v-if="
                                                                    Object.hasOwn(
                                                                        valbooking,
                                                                        'month'
                                                                    ) &&
                                                                    Object.hasOwn(
                                                                        valbooking,
                                                                        'year'
                                                                    )
                                                                "
                                                                class="card-date"
                                                            >
                                                                {{
                                                                    `${
                                                                        valbooking.day
                                                                    } de ${
                                                                        customModuleData
                                                                            .months[
                                                                            valbooking
                                                                                .month
                                                                        ]
                                                                    } de ${
                                                                        valbooking.year
                                                                    }`
                                                                }}
                                                            </p>
                                                            <p
                                                                v-else
                                                                class="card-date"
                                                            >
                                                                {{
                                                                    `${valbooking.day} de ${value.month} de ${value.year}`
                                                                }}
                                                            </p>
                                                            <p
                                                                class="card-hour"
                                                            >
                                                                {{
                                                                    `${valbooking.turndata.begin}:00-${valbooking.turndata.end}:00`
                                                                }}
                                                            </p>
                                                        </div>
                                                    </template>
                                                </figcaption>
                                            </figure>
                                        </div>
                                    </div>

                                    <div
                                        class="d-flex flex-row justify-content-center my-3"
                                    >
                                        <button
                                            class="btn btn-primary"
                                            type="button"
                                            aria-label="Load Data"
                                            data-action="load"
                                            :disabled="disabledload"
                                            @click="navActions($event)"
                                        >
                                            Carregar dados
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <h2 class="heading-5">
                                    Sem dados do utilizador para apresentar
                                </h2>
                            </div>
                        </template>
                    </div>

                    <!-- Module Form -->
                    <template v-else>
                        <module-form
                            :csrftolken="csrftolken"
                            :routine="moduleroutine"
                            :moduleindex="moduleindex"
                            :routineurl="routineurl"
                            :moduledata="moduleData"
                            :customdata="ruleList"
                            :disabledreturn="disabled"
                            :defaultsenddata="defaultSendDataStructure"
                            :moduledefaultindex="moduledefaultindex"
                        />
                    </template>
                </div>
            </div>

            <div v-else class="">
                <h1 class="heading-5">
                    Não existem dados para esta solicitação
                </h1>
            </div>

            <!-- Response Messages -->
            <div
                @click="closeMessageBox($event)"
                class="responsebasemessage"
                ref="responsebasemessage"
            >
                <list-message />
            </div>
        </div>
    </section>
</template>

<script>
import BackTo from "./../elements/BackToElement.vue";
import UserForm from "./UserForm.vue";
import defaultWebsite from "./../../defaultWebsiteScript.js";
import responseMessage from "./../../responseMessage.js";
import fetchData from "./../../fetchData.js";
import ListMessage from "./../elements/ListMessageElement.vue";
import Loading from "./../elements/LoadingElement.vue";
import ChartBarElement from "./../elements/ChartBarElement.vue";

("use strict");

export default {
    name: "UserRoutine",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        moduleindex: {
            type: String,
            required: true,
        },
        moduleroutine: {
            type: String,
            required: true,
        },
        storedata: {
            type: String,
            required: false,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        moduledefaultindex: {
            type: String,
            required: false,
        },
        customdata: {
            type: String,
            required: false,
        },
        modulename: {
            type: String,
            required: true,
        },
        moduleactive: {
            type: String,
            required: true,
        },
        professionalrule: {
            type: String,
            required: true,
        },
        modulerecoverpass: {
            type: String,
            required: true,
        },
        custommoduledata: {
            type: String,
            required: false,
        },
        modulehistory: {
            type: String,
            required: false,
        },
        moduleload: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            showformcreate: true,
            showformupdate: true,
            moduleData: [],
            urlback: "",
            ruleList: [],
            headertitle: "",
            adminDefaultKeysPersonal: [
                {
                    input: "Nome",
                    key: "user_name",
                },
                {
                    input: "Email",
                    key: "email",
                },
                {
                    input: "Função",
                    key: "position",
                },
                {
                    input: "Contato",
                    key: "contact",
                },
                {
                    input: "Registrado a",
                    key: "created_at",
                },
            ],
            professionalDefaultKeysPersonal: [
                {
                    input: "Nome",
                    key: "user_name",
                },
                {
                    input: "Email",
                    key: "email",
                },
                {
                    input: "Categoria",
                    key: "categories",
                },
                {
                    input: "NIF",
                    key: "nif",
                },
                {
                    input: "Telemóvel",
                    key: "contact",
                },
                {
                    input: "Registrado a",
                    key: "created_at",
                },
            ],
            personalDetails: [],
            disabled: false,
            responseTimeOut: 10000,
            userRule: "",
            activeclass: "d-flex",
            currentYear: "",
            spaceData: {},
            customModuleData: {},
            referenceBookingData: [],
            disabledfilter: false,
            bookingHistory: {},
            bookingHistoryRoutine: [],
            offset: 1,
            disabledload: false,
        };
    },
    created() {
        //Set Data
        this.moduleData = JSON.parse(this.moduledata);
        this.customModuleData = JSON.parse(this.custommoduledata);

        //Set Conditional
        this.showformcreate =
            this.moduleData.length === 0 && this.moduleroutine === "POST"
                ? true
                : false;
        this.showformupdate =
            this.moduleData.length > 0 && this.moduleroutine === "PUT"
                ? true
                : false;

        //Set Custom Data
        this.ruleList = JSON.parse(this.customdata);

        //Set Current Year
        let date = new Date();
        this.currentYear = date.getFullYear();

        //Set Personal Details
        if (this.showformupdate) {
            let ruledata = this.ruleList.find(
                (value) => value.role === this.moduleData[0].user_rule
            );
            this.userRule =
                ruledata !== undefined ? ruledata.name : "Profissional";
            let userConditional =
                this.moduleData[0].user_rule !== parseInt(this.professionalrule)
                    ? "admin"
                    : "professional";

            this.$data[`${userConditional}DefaultKeysPersonal`].forEach(
                (value) => {
                    let personalData = {
                        input: value.input,
                        value: this.moduleData[0][value.key],
                    };

                    if (
                        typeof personalData.value === "object" &&
                        ["contact"].includes(value.key) &&
                        userConditional === "professional"
                    ) {
                        personalData.value =
                            this.moduleData[0][value.key].contact || " - ";
                    }

                    this.personalDetails.push(personalData);
                }
            );
        }

        //Set Header Title
        this.headertitle =
            this.moduleroutine === "POST"
                ? `Novo ${this.modulename}`
                : `Editar ${this.modulename}`;

        //Set Url Back
        //this.urlback = history.back();
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        dynamicStyleModuleName(modulename) {
            return defaultWebsite.dynamicStyleModuleName(modulename);
        },
        defaultSendDataStructure(routineurl, dataForm, routine, action) {
            //Send Data
            let response = fetchData.structureTosendData(
                routineurl,
                dataForm,
                this.csrftolken,
                routine
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Check Response
                    if (Object.is(value.classname, "success")) {
                        switch (action) {
                            case "create":
                                setTimeout(() => {
                                    window.location.replace(this.moduleindex);
                                }, 3000);

                                break;

                            case "blockuser":
                                setTimeout(() => {
                                    window.location.reload();
                                }, 3000);

                                break;

                            case "history":
                                //Set Data
                                this.bookingHistory = JSON.parse(value.attData);
                                this.bookingHistoryRoutine =
                                    this.bookingHistory.current;

                                break;

                            case "load":
                                this.disabledload = false;
                                let loadData = JSON.parse(value.attData);

                                //Set Data
                                ["current", "old"].forEach((value) => {
                                    if (Object.hasOwn(loadData, value)) {
                                        loadData[`${value}`].forEach((val) =>
                                            this.bookingHistory[
                                                `${value}`
                                            ].push(val)
                                        );
                                    }
                                });

                                //Set Att List
                                let routine = [
                                    ...document.querySelectorAll(".buttonlist"),
                                ].find((value) =>
                                    value.classList.contains("active")
                                );
                                this.bookingHistoryRoutine =
                                    this.bookingHistory[
                                        `${routine.getAttribute("data-action")}`
                                    ];

                                //Conditional for generate more data
                                this.offset++;

                                break;
                        }
                    }

                    //Enabled Button
                    this.disabled = false;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
        buttonActions(element) {
            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Disable Button
            this.disabled = true;

            //Data Form
            let dataForm = {
                id: parseInt(element.currentTarget.getAttribute("data-userid")),
                action: element.currentTarget.getAttribute("data-action"),
            };

            //Set Action bu button
            switch (dataForm.action) {
                //Recover Pass
                case "recoverpass":
                    //Set data
                    dataForm.name = this.moduleData[0].user_name;
                    dataForm.email = this.moduleData[0].email;
                    dataForm.email_verified_at =
                        this.moduleData[0].email_verified_at;

                    this.defaultSendDataStructure(
                        this.modulerecoverpass,
                        dataForm,
                        "POST",
                        dataForm.action
                    );

                    break;

                //Block User
                case "blockuser":
                    //Set User Rule
                    dataForm.rule = parseInt(
                        element.currentTarget.getAttribute("data-userrule")
                    );

                    //Set Active Condition
                    dataForm.active =
                        element.currentTarget.getAttribute("data-active");

                    this.defaultSendDataStructure(
                        this.moduleactive,
                        dataForm,
                        "PATCH",
                        dataForm.action
                    );

                    break;
            }
        },
        navActions(element) {
            let action = element.currentTarget.getAttribute("data-action");

            if (!element.currentTarget.classList.contains("active")) {
                element.currentTarget.classList.add("active");
            }

            switch (action) {
                case "perfil":
                    this.$refs.history.classList.add("d-none");
                    this.$refs[action].classList.remove("d-none");
                    element.currentTarget.nextElementSibling.classList.remove(
                        "active"
                    );

                    break;

                case "history":
                    this.$refs.perfil.classList.add("d-none");
                    this.$refs[action].classList.remove("d-none");
                    element.currentTarget.previousElementSibling.classList.remove(
                        "active"
                    );

                    //Check First Booking History Request
                    if (Object.hasOwn(this.bookingHistory, "current")) {
                        return;
                    }

                    //Get Booking History
                    this.sendData(
                        this.modulehistory,
                        {
                            professional_id: this.moduleData[0].professional_id,
                        },
                        action
                    );

                    break;

                case "current":
                case "old":
                    this.bookingHistoryRoutine =
                        this.bookingHistory[`${action}`];

                    //Set class
                    [...document.querySelectorAll(".buttonlist")].forEach(
                        (value) => {
                            if (value.getAttribute("data-action") !== action) {
                                //Add class
                                value.classList.remove("active");
                            }
                        }
                    );

                    break;

                case "load":
                    this.disabledload = true;

                    this.sendData(
                        this.moduleload,
                        {
                            offset: this.offset,
                            professional_id: this.moduleData[0].professional_id,
                        },
                        action
                    );

                    break;
            }
        },
        filterItem(element) {
            let filtervalue = element.currentTarget.value.trim().toLowerCase();

            //Set Booking Data reference
            if (this.referenceBookingData.length === 0) {
                this.referenceBookingData = this.bookingHistoryRoutine;
            }

            let filterData = this.bookingHistoryRoutine.filter(
                (value) => value.month.trim().toLowerCase() === filtervalue
            );

            if (filterData.length === 0) {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "warning",
                    "Nenhum resultado encontrado",
                    "d-flex",
                    5000
                );

                return;
            }

            this.bookingHistoryRoutine = filterData;

            this.disabledfilter = true;
            this.disabledload = true;
        },
        filterClear() {
            if (this.referenceBookingData.length > 0) {
                this.bookingHistoryRoutine = this.referenceBookingData;
            }

            this.disabledfilter = false;
            this.disabledload = false;
        },
        sendData(url, dataForm, action, method = "POST") {
            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            this.defaultSendDataStructure(url, dataForm, method, action);
        },
    },
    computed: {
        computedBookingHistory() {
            return this.bookingHistory;
        },
        computedBookingHistoryRoutine() {
            return this.bookingHistoryRoutine;
        },
    },
    watch: {
        computedBookingHistory() {},
        computedBookingHistoryRoutine() {},
    },
    components: {
        backTo: BackTo,
        moduleForm: UserForm,
        listMessage: ListMessage,
        loading: Loading,
        chartBar: ChartBarElement,
    },
};
</script>
